import PropTypes from "prop-types";
import React from "react";

function VerticalTimelineItem({ children }) {
  return (
    <li className="event-list" style={{ paddingBottom: "15px !important" }}>
      <div className="event-timeline-dot">
        <i className="bx bx-right-arrow-circle font-size-18"></i>
      </div>
      <h5 className="font-size-14">{children}</h5>
    </li>
  );
}

VerticalTimelineItem.propTypes = {
  children: PropTypes.node.isRequired,
};

export default VerticalTimelineItem;
